import { action, actionOn, thunk } from "easy-peasy";
import axios from '../services/axios';

const ordersInitialState = {
    allOrders: [],
    allProducts: [],
    allProviders: [],
    isFetchingProviders: false,
    allOrderStatus: [],
    isFetchingAllOrders: false,
    isUpdateNecessary: false,
    initialFetchDone: false,
    allOrdersByClientId: [],
    isFetchingAllOrdersByClientId: false,
    orderById: null,
    isFetchingOneOrder: false,
    isFetchingHeadsetsByOrderId: false,
    headsetsByOrderId: [],

    allReturnOrders: [],
    allReturnOrderStatus: [],
    allReturnOrderTypes: [],
    allReturnProducts: [],
    isUpdateReturnOrdersNecessary: true,
    isFetchingAllReturnOrders: false,
    isFetchingOneReturnOrder: false,
    returnOrderById: null,
    isFetchingHeadsetsByReturnOrderId: false,
    headsetsByReturnOrderId: [],
    allReturnOrdersByClientId: [],
    isFetchingAllReturnOrdersByClientId: false,


    allLoaderAccesses: [],
    isUpdateLoaderAccessesNecessary: true,
    isFetchingAllLoaderAccesses: false,
    isFetchingOneLoaderAccessPings: false,

    allParcels: [],
    isUpdateParcelsNecessary: true,
    isFetchingAllParcels: false,

    allProductsLogistics: [],
    isUpdateProductsLogisticsNecessary: true,
    isFetchingAllProductsLogistics: false,
}

const orders = {
    ...ordersInitialState,

    onGlobalResetCalled: actionOn(
        (actions, storeActions) => [
            storeActions.resetStore.performReset,
        ],
        (state, target) => {
            const [performReset] = target.resolvedTargets;

            if (target.type === performReset) {
                ({
                    allOrders: state.allOrders,
                    allProducts: state.allProducts,
                    allProviders: state.allProviders,
                    isFetchingProviders: state.isFetchingProviders,
                    allOrderStatus: state.allOrderStatus,
                    isFetchingAllOrders: state.isFetchingAllOrders,
                    isUpdateNecessary: state.isUpdateNecessary,
                    initialFetchDone: state.initialFetchDone,
                    allOrdersByClientId: state.allOrdersByClientId,
                    isFetchingAllOrdersByClientId: state.isFetchingAllOrdersByClientId,
                    orderById: state.orderById,
                    isFetchingOneOrder: state.isFetchingOneOrder,
                    isFetchingHeadsetsByOrderId: state.isFetchingHeadsetsByOrderId,
                    headsetsByOrderId: state.headsetsByOrderId,

                    allReturnOrders: state.allReturnOrders,
                    allReturnOrderStatus: state.allReturnOrderStatus,
                    allReturnOrderTypes: state.allReturnOrderTypes,
                    allReturnProducts: state.allReturnProducts,
                    isFetchingAllReturnOrders: state.isFetchingAllReturnOrders,
                    isUpdateReturnOrdersNecessary: state.isUpdateReturnOrdersNecessary,
                    isFetchingHeadsetsByReturnOrderId: state.isFetchingHeadsetsByReturnOrderId,
                    headsetsByReturnOrderId: state.headsetsByReturnOrderId,
                    allReturnOrdersByClientId: state.allReturnOrdersByClientId,
                    isFetchingAllReturnOrdersByClientId: state.isFetchingAllReturnOrdersByClientId,


                    allLoaderAccesses: state.allLoaderAccesses,
                    isUpdateLoaderAccessesNecessary: state.isUpdateLoaderAccessesNecessary,
                    isFetchingAllLoaderAccesses: state.isFetchingAllLoaderAccesses,
                    isFetchingOneLoaderAccessPings: state.isFetchingOneLoaderAccessPings,

                    allParcels: state.allParcels,
                    isUpdateParcelsNecessary: state.isUpdateParcelsNecessary,
                    isFetchingAllParcels: state.isFetchingAllParcels,

                    allProductsLogistics: state.allProductsLogistics,
                    isUpdateProductsLogisticsNecessary: state.isUpdateProductsLogisticsNecessary,
                    isFetchingAllProductsLogistics: state.isFetchingAllProductsLogistics,

                } = ordersInitialState);
            }
        }
    ),

    setIsFetchingHeadsetsByOrderId: action((state, payload) => {
        state.isFetchingHeadsetsByOrderId = payload;
    }),

    setHeadsetsByOrderId: action((state, payload) => {
        state.headsetsByOrderId = payload;
    }),

    setIsFetchingHeadsetsByReturnOrderId: action((state, payload) => {
        state.isFetchingHeadsetsByReturnOrderId = payload;
    }),

    setHeadsetsByReturnOrderId: action((state, payload) => {
        state.headsetsByReturnOrderId = payload;
    }),

    setInitialFetchDone: action((state, payload) => {
        state.initialFetchDone = payload;
    }),

    setIsUpdateNecessary: action((state, payload) => {
        state.isUpdateNecessary = payload;
    }),

    setAllOrders: action((state, payload) => {
        state.allOrders = payload;
    }),

    setAllProducts: action((state, payload) => {
        state.allProducts = payload;
    }),

    setAllProviders: action((state, payload) => {
        state.allProviders = payload;
    }),

    setIsFetchingProviders: action((state, payload) => {
        state.isFetchingProviders = payload;
    }),

    setAllOrderStatus: action((state, payload) => {
        state.allOrderStatus = payload;
    }),

    setIsFetchingAllOrders: action((state, payload) => {
        state.isFetchingAllOrders = payload;
    }),

    fetchOrders: thunk((actions, payload, helpers) => {
        const { isFetchingAllOrders, isUpdateNecessary } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.orders?.readAll?.url;

        if (!isFetchingAllOrders && isUpdateNecessary) {
            actions.setIsFetchingAllOrders(true);
            return axios.get(getUrl)
                .then(data => {
                    actions.setAllOrders(data);
                    actions.fetchProducts();
                    actions.setIsUpdateNecessary(ordersInitialState.isUpdateNecessary);
                    return data;
                })
                .catch(error => Promise.reject(error))
                .finally(() => {
                    actions.setIsFetchingAllOrders(ordersInitialState.isFetchingAllOrders);
                })
        } else {
            Promise.resolve();
        }
    }),

    setAllOrdersByClientId: action((state, payload) => {
        state.allOrdersByClientId = payload;
    }),

    setIsFetchingAllOrdersByClientId: action((state, payload) => {
        state.isFetchingAllOrdersByClientId = payload;
    }),

    removeFromAllOrders: action((state, payload) => {
        const indexToRemove = state.allOrders.findIndex(order => order.uniqueId === payload);
        (indexToRemove !== -1) && state.allOrders.splice(indexToRemove, 1);
    }),

    removeFromAllOrdersByClientId: action((state, payload) => {
        const indexToRemove = state.allOrdersByClientId.findIndex(order => order.uniqueId === payload);
        (indexToRemove !== -1) && state.allOrdersByClientId.splice(indexToRemove, 1);
    }),

    fetchOrdersByClientId: thunk((actions, payload, helpers) => {
        const { isFetchingAllOrdersByClientId } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.orders?.readByClientId?.url?.replace("uniqueId", payload);

        if (!isFetchingAllOrdersByClientId) {
            actions.setIsFetchingAllOrders(true);
            actions.setAllOrdersByClientId(ordersInitialState.allOrdersByClientId);
            return axios.get(getUrl)
                .then(data => {
                    actions.setAllOrdersByClientId(data);
                    return data;
                })
                .catch(error => Promise.reject(error))
                .finally(() => {
                    actions.setIsFetchingAllOrders(ordersInitialState.isFetchingAllOrders);
                })
        } else {
            return Promise.resolve();
        }
    }),

    fetchProducts: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.orders?.getParams?.products?.url;
        return axios.get(getUrl)
            .then(data => {
                actions.setAllProducts(data);
            })
            .catch(error => Promise.reject(error))
    }),

    fetchProviders: thunk((actions, payload, helpers) => {
        if (helpers.getStoreState().orders.isFetchingProviders) {
            return Promise.resolve(helpers.getStoreState().orders.allProviders);
        }
        actions.setIsFetchingProviders(true);

        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.orders?.getParams?.providers?.url;
        return axios.get(getUrl)
            .then(data => {
                actions.setAllProviders(data);
                return data;
            })
            .catch(error => Promise.reject(error))
            .finally(() => actions.setIsFetchingProviders(false));
    }),

    // handlingOneOrder
    setOrderById: action((state, payload) => {
        state.orderById = payload;
    }),
    setIsFetchingOneOrder: action((state, payload) => {
        state.isFetchingOneOrder = payload;
    }),

    fetchOrderById: thunk((actions, payload, helpers) => {
        const { isFetchingOneOrder } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.orders?.readOne?.url?.replace('uniqueId', payload);

        if (!isFetchingOneOrder) {
            actions.setIsFetchingOneOrder(true);
            actions.setOrderById(ordersInitialState.orderById);
            return axios.get(getUrl)
                .then(data => {
                    actions.setIsFetchingOneOrder(ordersInitialState.isFetchingOneOrder);
                    actions.setOrderById(data);
                    return data;
                })
                .catch(error => Promise.reject(error))
        } else {
            return Promise.resolve();
        }
    }),

    addOrder: action((state, payload) => {
        state.allOrders.push(payload);
    }),

    updateAllOrders: action((state, payload) => {
        const index = state.allOrders.findIndex((order) => order.uniqueId === payload.uniqueId);

        state.allOrders[index] = {
            ...state.allOrders[index],
            ...payload,
        };

    }),

    // createOneOrder
    createOrder: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const createOrderUrl = ACTIONS?.orders?.create?.url;
        payload.csrfToken = ACTIONS?.orders?.create?.csrfToken;

        return axios.post(createOrderUrl, payload)
            .then((result) => {
                actions.addOrder(result.orderToAdd);
                actions.setOrderById(result.orderToAdd);
                return result.orderToAdd;
            })
            .catch(error => Promise.reject(error));
    }),

    // deleteOneOrder
    deleteOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const apiData = helpers.getStoreState().actionSlugs.apiData;

        const formData = new FormData();
        formData.set(`${apiData.ACTIONS?.orders?.deleteOrder?.formName}[token]`, apiData.ACTIONS?.orders?.deleteOrder?.csrfToken)
        const deleteOrderUrl = apiData.ACTIONS?.orders?.deleteOrder?.url?.replace('uniqueId', uniqueId);

        return axios.delete(deleteOrderUrl, formData)
            .then((deletedOrder) => {
                const { clientCRMById } = helpers.getStoreState().clients;
                if (clientCRMById && clientCRMById.uniqueId === deletedOrder.clientUniqueId) {
                    actions.removeFromAllOrdersByClientId(deletedOrder.uniqueId);
                }
                actions.removeFromAllOrders(deletedOrder.uniqueId);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    // updateOrder
    updateOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const updateOrderUrl = ACTIONS?.orders?.update?.url?.replace('uniqueId', uniqueId);
        payload.csrfToken = ACTIONS?.orders?.update?.csrfToken;

        return axios.post(updateOrderUrl, payload)
            .then((result) => {
                actions.updateAllOrders(result.orderToUpdate);
                actions.setOrderById(result.orderToUpdate);
                return result.orderToUpdate;
            })
            .catch(error => Promise.reject(error));
    }),

    // validateOrder
    validateOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const updateOrderUrl = ACTIONS?.orders?.actions?.validate?.url?.replace('uniqueId', uniqueId);
        payload.csrfToken = ACTIONS?.orders?.actions?.validate?.csrfToken;

        return axios.post(updateOrderUrl, payload)
            .then((result) => {
                actions.updateAllOrders(result.orderToUpdate);
                actions.setOrderById(result.orderToUpdate);
                return result.orderToUpdate;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    // unvalidateOrder
    unvalidateOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const updateOrderUrl = ACTIONS?.orders?.actions?.unvalidate?.url?.replace('uniqueId', uniqueId);
        payload.csrfToken = ACTIONS?.orders?.actions?.unvalidate?.csrfToken;

        return axios.post(updateOrderUrl, payload)
            .then((result) => {
                actions.updateAllOrders(result.orderToUpdate);
                actions.setOrderById(result.orderToUpdate);
                return result.orderToUpdate;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    fetchOrderStatus: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.orders?.getParams?.status?.url;
        return axios.get(getUrl)
            .then(data => {
                actions.setAllOrderStatus(data);
                return data;
            })
            .catch(error => {
                return Promise.reject(error);
            })
    }),


    //#region Return Orders
    setAllReturnOrders: action((state, payload) => {
        state.allReturnOrders = payload;
    }),

    setIsUpdateReturnOrdersNecessary: action((state, payload) => {
        state.isUpdateReturnOrdersNecessary = payload;
    }),

    setIsFetchingAllReturnOrders: action((state, payload) => {
        state.isFetchingAllReturnOrders = payload;
    }),

    setIsFetchingOneReturnOrder: action((state, payload) => {
        state.isFetchingOneReturnOrder = payload;
    }),

    setReturnOrderById: action((state, payload) => {
        state.returnOrderById = payload;
    }),

    addReturnOrder: action((state, payload) => {
        state.allReturnOrders.push(payload);
    }),

    setAllReturnOrderStatus: action((state, payload) => {
        state.allReturnOrderStatus = payload;
    }),

    setAllReturnOrderTypes: action((state, payload) => {
        state.allReturnOrderTypes = payload;
    }),

    setAllReturnProducts: action((state, payload) => {
        state.allReturnProducts = payload;
    }),

    removeFromAllReturnOrders: action((state, payload) => {
        const indexToRemove = state.allReturnOrders.findIndex(order => order.uniqueId === payload);
        (indexToRemove !== -1) && state.allReturnOrders.splice(indexToRemove, 1);
    }),

    updateAllReturnOrders: action((state, payload) => {
        const index = state.allReturnOrders.findIndex((order) => order.uniqueId === payload.uniqueId);

        state.allReturnOrders[index] = {
            ...state.allReturnOrders[index],
            ...payload,
        };

    }),

    setAllReturnOrdersByClientId: action((state, payload) => {
        state.allReturnOrdersByClientId = payload;
    }),

    setIsFetchingAllReturnOrdersByClientId: action((state, payload) => {
        state.isFetchingAllReturnOrdersByClientId = payload;
    }),

    removeFromAllReturnOrdersByClientId: action((state, payload) => {
        const indexToRemove = state.allReturnOrdersByClientId.findIndex(order => order.uniqueId === payload);
        (indexToRemove !== -1) && state.allReturnOrdersByClientId.splice(indexToRemove, 1);
    }),

    fetchReturnOrderStatus: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.returnOrders?.getParams?.returnStatus?.url;

        return axios.get(getUrl)
            .then(data => {
                actions.setAllReturnOrderStatus(data);
                return data;
            })
            .catch(error => {
                return Promise.reject(error);
            })
    }),

    fetchReturnOrderTypes: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.returnOrders?.getParams?.typesOfReturn?.url;

        return axios.get(getUrl)
            .then(data => {
                actions.setAllReturnOrderTypes(data);
                return data;
            })
            .catch(error => {
                return Promise.reject(error);
            })
    }),

    fetchReturnOrders: thunk((actions, payload, helpers) => {
        const { isFetchingAllReturnOrders, isUpdateReturnOrdersNecessary } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.returnOrders?.readAll?.url;

        if (!isFetchingAllReturnOrders && isUpdateReturnOrdersNecessary) {
            actions.setIsFetchingAllReturnOrders(true);
            return axios.get(getUrl)
                .then(data => {
                    actions.setAllReturnOrders(data);
                    actions.setIsUpdateReturnOrdersNecessary(false);
                    actions.setIsFetchingAllReturnOrders(false);
                    return data;
                })
                .catch(error => {
                    actions.setIsFetchingAllReturnOrders(false);
                    return Promise.reject(error);
                })
        } else {
            return Promise.resolve();
        }
    }),

    fetchReturnOrdersByClientId: thunk((actions, payload, helpers) => {
        const { isFetchingAllReturnOrdersByClientId } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.returnOrders?.readByClientId?.url?.replace("uniqueId", payload);

        if (!isFetchingAllReturnOrdersByClientId) {
            actions.setIsFetchingAllReturnOrders(true);
            actions.setAllReturnOrdersByClientId(ordersInitialState.allReturnOrdersByClientId);
            return axios.get(getUrl)
                .then(data => {
                    actions.setAllReturnOrdersByClientId(data);
                    return data;
                })
                .catch(error => Promise.reject(error))
                .finally(() => {
                    actions.setIsFetchingAllReturnOrders(false);
                })
        } else {
            return Promise.resolve();
        }
    }),

    fetchReturnOrderById: thunk((actions, payload, helpers) => {
        const { isFetchingOneReturnOrder } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.returnOrders?.readOne?.url?.replace('uniqueId', payload);

        if (!isFetchingOneReturnOrder) {
            actions.setIsFetchingOneReturnOrder(true);
            actions.setReturnOrderById(ordersInitialState.orderById);
            return axios.get(getUrl)
                .then(data => {
                    actions.setReturnOrderById(data);
                    return data;
                })
                .catch(error => {
                    return Promise.reject(error);
                })
                .finally(actions.setIsFetchingOneReturnOrder(false))
        } else {
            actions.setIsFetchingOneReturnOrder(false);
            return Promise.resolve();
        }
    }),

    createReturnOrder: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const createReturnOrderUrl = ACTIONS?.returnOrders?.create?.url;
        payload.csrfToken = ACTIONS?.returnOrders?.create?.csrfToken;

        return axios.post(createReturnOrderUrl, payload)
            .then((result) => {
                actions.addReturnOrder(result.returnOrderToAdd);
                actions.setReturnOrderById(result.returnOrderToAdd);
                return result.returnOrderToAdd;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    deleteReturnOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const apiData = helpers.getStoreState().actionSlugs.apiData;

        const deleteOrderUrl = apiData.ACTIONS?.returnOrders?.delete?.url?.replace('uniqueId', uniqueId);
        const csrfToken = apiData.ACTIONS?.returnOrders?.delete?.csrfToken;

        return axios.post(deleteOrderUrl, {csrfToken})
            .then((deletedOrder) => {
                const { clientCRMById } = helpers.getStoreState().clients;
                if (clientCRMById?.uniqueId === deletedOrder.clientUniqueId) {
                    actions.removeFromAllReturnOrdersByClientId(deletedOrder.uniqueId);
                }
                actions.removeFromAllReturnOrders(deletedOrder.uniqueId);
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    updateReturnOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const updateOrderUrl = ACTIONS?.returnOrders?.update?.url?.replace('uniqueId', uniqueId);
        payload.csrfToken = ACTIONS?.returnOrders?.update?.csrfToken;

        return axios.post(updateOrderUrl, payload)
            .then((result) => {
                actions.updateAllReturnOrders(result.returnOrderToUpdate);
                actions.setReturnOrderById(result.returnOrderToUpdate);
                return result.returnOrderToUpdate;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    validateReturnOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const updateOrderUrl = ACTIONS?.returnOrders?.actions?.validate?.url?.replace('uniqueId', uniqueId);
        payload.csrfToken = ACTIONS?.returnOrders?.actions?.validate?.csrfToken;

        return axios.post(updateOrderUrl, payload)
            .then((result) => {
                actions.updateAllReturnOrders(result);
                actions.setReturnOrderById(result);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    unvalidateReturnOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const updateOrderUrl = ACTIONS?.returnOrders?.actions?.unvalidate?.url?.replace('uniqueId', uniqueId);
        payload.csrfToken = ACTIONS?.returnOrders?.actions?.unvalidate?.csrfToken;

        return axios.post(updateOrderUrl, payload)
            .then((result) => {
                actions.updateAllReturnOrders(result);
                actions.setReturnOrderById(result);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    closeReturnOrder: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const updateOrderUrl = ACTIONS?.returnOrders?.actions?.close?.url?.replace('uniqueId', uniqueId);
        payload.csrfToken = ACTIONS?.returnOrders?.actions?.close?.csrfToken;

        return axios.post(updateOrderUrl, payload)
            .then((result) => {
                actions.updateAllReturnOrders(result);
                actions.setReturnOrderById(result);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    fetchReturnProducts: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.returnOrders?.getParams?.products?.url;
        return axios.get(getUrl)
            .then(data => {
                actions.setAllReturnProducts(data);
            })
            .catch(error => {
                return Promise.reject(error);
            })
    }),

    //#endregion

    //#region Loader Accesses
    setAllLoaderAccesses: action((state, payload) => {
        state.allLoaderAccesses = payload;
    }),
    setIsUpdateLoaderAccessesNecessary: action((state, payload) => {
        state.isUpdateLoaderAccessesNecessary = payload;
    }),
    setIsFetchingAllLoaderAccesses: action((state, payload) => {
        state.isFetchingAllLoaderAccesses = payload;
    }),
    setIsFetchingOneLoaderAccessPings: action((state, payload) => {
        state.isFetchingOneLoaderAccessPings = payload;
    }),


    fetchLoaderAccesses: thunk((actions, payload, helpers) => {
        const { isFetchingAllLoaderAccesses, isUpdateLoaderAccessesNecessary } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.loaderAccess?.readAll?.url;

        if (!isFetchingAllLoaderAccesses && isUpdateLoaderAccessesNecessary) {

            actions.setIsFetchingAllLoaderAccesses(true);
            return axios.get(getUrl)
                .then(data => {
                    actions.setAllLoaderAccesses(data);
                    actions.setIsUpdateLoaderAccessesNecessary(false);
                    return data;
                })
                .catch(error => {
                    return Promise.reject(error);
                })
                .finally(() => {
                    actions.setIsFetchingAllLoaderAccesses(false);
                })
        } else {
            return Promise.resolve();
        }
    }),


    fetchOneLoaderAccessPings: thunk((actions, payload, helpers) => {
        const { isFetchingOneLoaderAccessPings } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.loaderAccess?.readOnePings?.url?.replace('uniqueId', payload);



        if (!isFetchingOneLoaderAccessPings) {
            actions.setIsFetchingOneLoaderAccessPings(true);
            return axios.get(getUrl)
                .then(data => {
                    return data;
                })
                .catch(error => {
                    return Promise.reject(error);
                })
                .finally(() => {
                    actions.setIsFetchingOneLoaderAccessPings(false);
                })
        } else {
            return Promise.resolve();
        }
    }),
    //#endregion

    //#region Parcels
    setAllParcels: action((state, payload) => {
        state.allParcels = payload;
    }),
    setIsUpdateParcelsNecessary: action((state, payload) => {
        state.isUpdateParcelsNecessary = payload;
    }),
    setIsFetchingAllParcels: action((state, payload) => {
        state.isFetchingAllParcels = payload;
    }),


    fetchParcels: thunk((actions, payload, helpers) => {
        const { isFetchingAllParcels, isUpdateParcelsNecessary } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.parcels?.readAll?.url;

        if (!isFetchingAllParcels && isUpdateParcelsNecessary) {

            actions.setIsFetchingAllParcels(true);
            return axios.get(getUrl)
                .then(data => {
                    actions.setAllParcels(data);
                    actions.setIsUpdateParcelsNecessary(false);
                    return data;
                })
                .catch(error => {
                    return Promise.reject(error);
                })
                .finally(() => {
                    actions.setIsFetchingAllParcels(false);
                })
        } else {
            return Promise.resolve();
        }
    }),


    fetchHeadsetsByOrderId: thunk((actions, payload, helpers) => {
        const { isFetchingHeadsetsByOrderId, orderById } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.orders?.getProps?.getHeadsets?.url?.replace('uniqueId', orderById?.uniqueId);

        if (!orderById?.headsets?.length) {
            actions.setHeadsetsByOrderId([]);
            return;
        }
        if (isFetchingHeadsetsByOrderId) {
            return Promise.resolve();
        }

        if (!getUrl) return;

        actions.setHeadsetsByOrderId([]);
        actions.setIsFetchingHeadsetsByOrderId(true);
        return axios.get(getUrl)
            .then(data => {
                actions.setHeadsetsByOrderId(data?.headsets);
                return data;
            })
            .catch(error => Promise.reject(error))
            .finally(() => {
                actions.setIsFetchingHeadsetsByOrderId(ordersInitialState.isFetchingHeadsetsByOrderId);
            });
    }),

    fetchHeadsetsByReturnOrderId: thunk((actions, payload, helpers) => {
        const { isFetchingHeadsetsByReturnOrderId, returnOrderById } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.returnOrders?.getProps?.getHeadsets?.url?.replace('uniqueId', returnOrderById?.uniqueId);

        if (!returnOrderById?.returnedProducts?.length) {
            actions.setHeadsetsByReturnOrderId([]);
            return;
        }
        if (isFetchingHeadsetsByReturnOrderId) {
            return Promise.resolve();
        }

        if (!getUrl) return;

        actions.setHeadsetsByReturnOrderId([]);
        actions.setIsFetchingHeadsetsByReturnOrderId(true);
        return axios.get(getUrl)
            .then(data => {
                actions.setHeadsetsByReturnOrderId(data?.headsets);
                return data;
            })
            .catch(error => Promise.reject(error))
            .finally(() => {
                actions.setIsFetchingHeadsetsByReturnOrderId(ordersInitialState.isFetchingHeadsetsByReturnOrderId);
            });
    }),

    //#endregion

    //#region Products logistics
    setAllProductsLogistics: action((state, payload) => {
        state.allProductsLogistics = payload;
    }),
    setIsUpdateProductsLogisticsNecessary: action((state, payload) => {
        state.isUpdateProductsLogisticsNecessary = payload;
    }),
    setIsFetchingAllProductsLogistics: action((state, payload) => {
        state.isFetchingAllProductsLogistics = payload;
    }),
    updateProductLogisticsInList: action((state, payload) => {
        const index = state.allProductsLogistics.findIndex(p => p.uniqueId === payload.uniqueId);
        if (index !== -1) {
            state.allProductsLogistics[index] = { ...state.allProductsLogistics[index], ...payload };
        }
    }),

    fetchAllProductsLogistics: thunk((actions, payload, helpers) => {
        const { isFetchingAllProductsLogistics, isUpdateProductsLogisticsNecessary } = helpers.getState();
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const getUrl = ACTIONS?.products?.readAll?.url;

        if (!isFetchingAllProductsLogistics && isUpdateProductsLogisticsNecessary) {
            actions.setIsFetchingAllProductsLogistics(true);
            return axios.get(getUrl)
                .then(data => {
                    actions.setAllProductsLogistics(data);
                    actions.setIsUpdateProductsLogisticsNecessary(false);
                    return data;
                })
                .catch(error => Promise.reject(error))
                .finally(() => {
                    actions.setIsFetchingAllProductsLogistics(false);
                });
        } else {
            return Promise.resolve();
        }
    }),

    updateProductAvailability: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const { uniqueId, isAvailable } = payload;

        const url = ACTIONS?.products?.updateAvailability?.url?.replace('uniqueId', uniqueId);
        const csrfToken = ACTIONS?.products?.updateAvailability?.csrfToken;

        return axios.patch(url, { csrfToken, isAvailable })
            .then(data => {
                actions.updateProductLogisticsInList({ uniqueId, isAvailable });
                return data;
            })
            .catch(error => Promise.reject(error));
    }),

    updateProductHeadset: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const { uniqueId, reference } = payload;

        const url = ACTIONS?.products?.updateHeadset?.url?.replace('uniqueId', uniqueId);
        const csrfToken = ACTIONS?.products?.updateHeadset?.csrfToken;

        return axios.patch(url, { csrfToken, reference })
            .then(data => {
                actions.updateProductLogisticsInList({ uniqueId, reference, isHeadset: reference !== '' });
                return data;
            })
            .catch(error => Promise.reject(error));
    }),

    createProductOnPipedrive: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const { uniqueId } = payload;

        const url = ACTIONS?.products?.createPipedrive?.url?.replace('uniqueId', uniqueId);
        const csrfToken = ACTIONS?.products?.createPipedrive?.csrfToken;

        return axios.post(url, { csrfToken })
            .then(data => {
                actions.updateProductLogisticsInList({ uniqueId, idPipedrive: data.idPipedrive });
                return data;
            })
            .catch(error => Promise.reject(error));
    }),
    //#endregion
};

export default orders;
